import vueDragResizeRotate from './lib/vueDragResizeRotate.vue';
import './assets/iconfont/iconfont.css'
vueDragResizeRotate.install = Vue=>Vue.component(vueDragResizeRotate.name,vueDragResizeRotate);
export default vueDragResizeRotate;


// WEBPACK FOOTER //
// ./src/index.js